import 'loaders.css/loaders.min.css';
import hexToRgba from 'hex-to-rgba';
import Loader from 'react-loaders';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'react-emotion';

import { CATEGORY, SIZE, TIER } from './constants';
import Style from '../../styles/common';

const Primary = styled('button')`
  background: ${props => getButtonColor(props.loading, props.category, props.tier)};
  border-color: ${props => getButtonColor(props.loading, props.category, props.tier)};
  border-radius: 5px;
  color: ${Style.color.buttonText};
  font-size: ${Style.FONT_SIZE.S};
  font-weight: 700;
  height: ${props => Style.MEASUREMENT.BUTTON.HEIGHT[props.size]};
  letter-spacing: 0.5px;
  min-width: ${props => props.size === SIZE.S ? 0 : Style.MEASUREMENT.BUTTON.MIN_WIDTH};
  padding: 0 20px;

  display: inline-block;
  transform: translateZ(0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition-duration: 0.3s;
  transition-property: transform;
  vertical-align: middle;
  
  &:hover {
    box-shadow: ${props => props.loading ? 'none' : '0 2px 5px 2px rgba(0,0,0,.1)'};
    transform: ${props => props.loading ? 'scale(1)' : 'scale(1.01)'};
  }

  &:active {
    box-shadow: none;
    transform: scale(0.99);
  }

  &:focus {
    outline: none;
  }
`;

const Secondary = styled(Primary)`
  background: ${props => getButtonColor(props.loading, props.category, props.tier)};
  border-color: ${props => hexToRgba(getButtonColor(props.loading, props.category), 0.5)};
  color: ${props => getButtonColor(props.loading, props.category)};
  
  &:hover {
    box-shadow: ${props => props.loading ? 'none' : '0 2px 5px 0 rgba(0,0,0,.05)'};
  }
`;

function getButtonColor(loading, category, tier = null) {
  if (loading) {
    return Style.color.BTN_DISABLED;
  }

  if (tier === TIER.SECONDARY) {
    return Style.color.BTN_SECONDARY;
  }

  return Style.color.BTN[category];
}

export default class Button extends React.Component {
  static propTypes = {
    category: PropTypes.string,
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.string,
    tier: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    category: CATEGORY.NEUTRAL,
    className: '',
    disabled: false,
    loading: false,
    onClick: () => {},
    size: SIZE.M,
    tier: TIER.PRIMARY,
    type: 'button',
  };

  render() {
    const StyledButton = this.props.tier === TIER.PRIMARY ? Primary : Secondary;

    return (
      <StyledButton
        category={this.props.category}
        className={this.props.className} // To enable extending styles using Emotion https://emotion.sh/docs/styled#styling-any-component
        disabled={this.props.disabled}
        loading={this.props.loading}
        onClick={this.props.onClick}
        size={this.props.size}
        tier={this.props.tier}
        type={this.props.type}
      >
        {this.buttonContent}
      </StyledButton>
    );
  }

  get buttonContent() {
    return this.props.loading ? (
      <Loader type="ball-pulse" active style={{ transform: 'scale(0.75)' }} />
    ) : this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/Button.js